import { defaultThemeTokens } from "./defaultTheme";
import type { ThemeApiResponse, ThemeConfig, ThemeTokens } from "./types";

export function mergeThemeTokens(
  partial?: Partial<ThemeTokens> | null,
): ThemeTokens {
  return {
    primary: partial?.primary ?? defaultThemeTokens.primary,
    background: partial?.background ?? defaultThemeTokens.background,
    text: partial?.text ?? defaultThemeTokens.text,
  };
}

export function normalizeThemeResponse(data: ThemeApiResponse): ThemeConfig {
  const fromNested = data.tokens;
  const fromFlat: Partial<ThemeTokens> = {
    primary: data.primary,
    background: data.background,
    text: data.text,
  };

  return {
    platform: data.platform,
    tokens: mergeThemeTokens({ ...fromFlat, ...fromNested }),
  };
}

/** @deprecated Use mergeThemeTokens — kept as alias for existing imports. */
export const createAppTheme = mergeThemeTokens;
